import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPropertyUnits } from 'modules/accommodations/features/reservations/api';

export const useQueryPropertyUnits = (propertyId: string | undefined) => {
  const {
    data: propertyUnitsData,
    isLoading,
    refetch,
  } = useQuery(
    [QUERY_KEYS.RENTALS_PROPERTY_UNITS, propertyId],
    () => getPropertyUnits(propertyId),
    { enabled: !!propertyId, refetchOnMount: true },
  );

  return { propertyUnitsData: propertyUnitsData?.items, refetch, isLoading };
};
